import api from '../API';
import { Template, TemplateFilters } from '../types';

export default {
  find(id: string): Promise<Template> {
    return api
      .get(`templates/${id}`)
      .then(response => response.data);
  },
  findAll(filters: TemplateFilters): Promise<Template[]> {
    return api
      .get(`accounts/${filters.accountId}/templates`, { params: filters })
      .then(response => response.data);
  },
};
